import { compose } from '@/utils';

const defaultLocationInterceptor = location => {
  if(typeof location === 'string') {
    return { path: location };
  }
  return location;
}

export default function (router) {

  router.__interceptors = [defaultLocationInterceptor]

  function addInterceptor(fn) {
    return router.__interceptors.push(fn) - 1
  }

  function removeInterceptor(id) {
    router.__interceptors[id] = null
  }

  function runInterceptors(location) {
    return compose(router.__interceptors.filter(Boolean))(location)
  }

  const rawPush = router.push.bind(router)
  router.push = function (location, ...args) {
    const nextLocation = runInterceptors(location)
    return rawPush(nextLocation, ...args)
  }

  const rawReplace = router.replace.bind(router)
  router.replace = function (location, ...args) {
    const nextLocation = runInterceptors(location)
    return rawReplace(nextLocation, ...args)
  }

  router.addInterceptor = addInterceptor.bind(router);

  router.removeInterceptor = removeInterceptor.bind(router);

  return router
}